<template>
  <klereo-modal
    :opened="opened"
    :with-close-button="true"
    @close="emit('cancel')"
  >
    <div class="mb-5">
      {{ $t("BleConfirmForgetText") }}
    </div>

    <div class="flex gap-2 justify-end">
      <div class="btn--secondary" @click="emit('cancel')">
        {{ $t("Abort") }}
      </div>
      <div class="btn--primary" @click="forget">
        {{ $t("BleForgetAction") }}
      </div>
    </div>
  </klereo-modal>
</template>
<script setup lang="ts">
import KlereoModal from "@/shared/components/KlereoModal.vue";
import { removeBlePool } from "@/features/ble/utils/localStorage.ts";
import { PoolDetails } from "@/models/pool-details.model.ts";

const { pool } = defineProps<{
  opened: boolean;
  pool: PoolDetails & { deviceId: string; localNickname: string };
}>();
const emit = defineEmits<{ cancel: [void: void]; submit: [void: void] }>();

const forget = () => {
  console.log(pool);
  removeBlePool(pool.deviceId);
  emit("submit");
};
</script>
